export default __webpack_public_path__ + "static/char-18-f8cd8040f0b5c94322264f165a363b77.webp";